const isDevMode = process.env.NODE_ENV !== 'prod';

const logCat = () => {
  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

  if (!isChrome) return console.log('Welcome Fastcampus v2');

  console.log(
    `%c
 ---------------------------------------------------
< Welcome Fastcampus v2. Come to join our developers! >
 ---------------------------------------------------
      /\\__/\\
     /'    '\\
   === 0  0 ===
     \\  --  /
    /        \\
   /          \\
  |            |
   \\  ||  ||  /
    \\_oo__oo_/#######o`,
    'font-family:monospace'
  );
};

const logDescription = () => {
  console.info("To see console debug logs. use localStorage environment: localStorage.debug = 'fc:*';");
};

const init = (debug) => {
  const log = debug('fc:lib');
  logCat();
  isDevMode && logDescription();
  return {
    run(list) {
      list.map((module) => {
        module(debug('fc:' + (module.name || 'default')));
        log(`init ${module.name}`);
      });
    },
  };
};

export default {
  init,
};
